// extracted by mini-css-extract-plugin
var _1 = "src-components-common-Panels-module__bigPanel";
export { _1 as "bigPanel" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"bigPanel\":\"src-components-common-Panels-module__bigPanel\"}";
        // 1772132917700
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  